import { render } from "./BaseSwitcher.vue?vue&type=template&id=5f591913&ts=true"
import script from "./BaseSwitcher.vue?vue&type=script&lang=ts"
export * from "./BaseSwitcher.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__